import {apitoken } from "../constants/app-constants";
import axiosClient from "./api-handlers";
import axiosCMS from "./cms-api-handlers";
import axiosMHClient from "./second-api-handlers";

export async function searchTextAPI(keyword, type) {
  if (keyword === "") return false;
  let payLoad = {
    keyword: keyword,
    type: type,
  };

  const response = await axiosMHClient.post(
    `/patients/android/v2/global-search`,
    payLoad
  );
  return response;
}

export async function doctorAvailabilityByFilter(specialId, hId, payLoad) {
  let hospitalId = hId !== "" ? "?hospital_id=" + hId : "";
  const response = await axiosMHClient.post(
    `/patients/web/v2/specialities/${specialId}/doctors${hospitalId}`,
    payLoad
  );
  return response;
}

export async function getOTP(uid) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/get-otp?uid=${uid}`
  );
  return response;
}

export async function getOTPWithPayload(payload) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/get-otp`,
    payload
  );
  return response;
}

export async function getOTPWithPayloadTokenBased(payload, token) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/get-otp`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    }
  );
  return response;
}

//register api
export async function registerOTP(payload) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/register`,
    payload
  );
  return response;
}

//verify OTP
export async function verifyMobileOTP(payload) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/verify-otp`,
    payload
  );
  return response;
}

export async function verifyMobileOTPTokenBased(payload, token) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/verify-otp`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    }
  );
  return response;
}

export async function bookAppointmentHospital(payload, JWT) {
  const response = await axiosClient.post(
    `/patients/web/v2/doctors/book-appointment`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

export async function applyCoupon(payload, token) {
  console.log("payload apply-coupon", payload)
  const response = await axiosClient.post(
    `/patients/web/v2/doctors/appointment/apply-coupon`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    }
  );
  return response;
}

export async function removeCoupon(payload, token) {
  const response = await axiosClient.post(
    `/patients/web/v2/doctors/appointment/remove-coupon`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    }
  );
  return response;
}

export async function removeWallet(payload, token) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/remove-apply-wallet`,
    payload,
    {
      headers: {
        // Accept: "application/json",
        // "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    }
  );
  return response;
}

export async function addWallet(payload, token) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/apply-wallet`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    }
  );
  return response;
}

export async function updateFamilyMember(payload, jwt) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/profile/update`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${jwt}`,
      },
    }
  );
  return response;
}

export async function addFamilyMember(payload, jwt) { 
  const response = await axiosClient.post(
    `/patients/web/v2/patients/family-members/add`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${jwt}`,
      },
    }
  );
  return response;
}

export async function switchPatient(payload, token) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/switch`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    }
  );
  return response;
}

export async function payLater(payload, token) {
  const response = await axiosClient.post(
    `/patients/web/v2/doctors/pay-later`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    }
  );
  return response;
}

export async function compareThyrocare(payload) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/compare-thyrocare-package`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        aggregatorType: "market_place",
        apitoken: apitoken,
      },
    }
  );
  return response;
}

export async function compareHomecarePackage(payload) {
  const response = await axiosClient.post(
    `/patients/ios/v2/tests/compare`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        aggregatorType: "market_place",
        apitoken: apitoken,
      },
    }
  );
  return response;
}

export async function orderPackage(payload) {
  
  const response = await axiosClient.post(
    `/patients/web/v2/patients/create-order`,
    // `/patients/ios/v2/special-health-offers/confirm-booking`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        aggregatorType: "market_place",
        apitoken: apitoken,
      },
    }
  );
  return response;
}
export async function orderProgram(payload) {
  
  const response = await axiosClient.post(

    `/patients/web/v2/special-health-offers/confirm-booking`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        aggregatorType: "market_place",
        apitoken: apitoken,
      },
    }
  );
  return response;
}

/*
// For MHVC Store a request call back
export async function bookHomecarePackage(payload) {
  const response = await axiosCMS.post(
    `/store_homecare_request`,
    // `/store_request`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        aggregatorType: "market_place",
        apitoken: apitoken,
      },
    }
  );
  return response;
}

*/




export async function leadSquaredStatus(payload) { 
  const response = await axiosMHClient.post(
    `https://api-in21.leadsquared.com/v2/LeadManagement.svc/Lead.Capture?accessKey=u$rcb2c77416f4a3b2526306fa19cadfcb9&secretKey=19970adaf27c394da2f291973b06b210d34f8c4c`,
    
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      
      },
    }
  );
  return response;
}